import { ProgressLine } from '@consta/uikit/ProgressLine'
import type { FC, PropsWithChildren } from 'react'

import { CenteredLoader } from '../CenteredLoader'
import { LoadingFailed, NothingFound } from '../Responses'
import css from './Status.css'

type AdditionalState =
  | {
      status: 'pending' | 'fulfilled'
      error: null
    }
  | { status: 'rejected'; error: string }

type FlatAdditionalState = {
  status: AdditionalState['status']
  error: AdditionalState['error']
}

type StatusProps = {
  status: FlatAdditionalState
  size?: 's' | 'm' | 'l'
  loader?: 'dots' | 'line'
} & (
  | { items: unknown[]; noObjectComment: string }
  | {
      items?: never
      noObjectComment?: never
    }
)

export const Status: FC<PropsWithChildren<StatusProps>> = ({
  children,
  items,
  noObjectComment,
  status,
  size = 'm',
  loader = 'dots',
}) => {
  if (status.status === 'pending') {
    if (loader === 'line') {
      return (
        <>
          <ProgressLine className={css.progressLineLoader} size={size as 'm'} />
          {children}
        </>
      )
    }

    return <CenteredLoader size={size as 'm'} />
  }

  if (status.status === 'rejected') {
    return <LoadingFailed description={status.error} size={size as 'm'} />
  }

  if (items && items.length === 0) {
    return <NothingFound description={noObjectComment} size={size as 'm'} />
  }

  return children
}
